/* ============================================================
   rm-motion.js — Elevated motion layer for Ro.lexx theme
   Page transitions · Custom cursor · Parallax · Smooth clock
   ============================================================ */

(function () {
  'use strict';

  /* ── Respect reduced motion ── */
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ================================================================
     1. PAGE TRANSITION OVERLAY
     A white veil that fades out on enter, fades in on leave
  ================================================================ */
  var veil = document.createElement('div');
  veil.id = 'rm-veil';
  veil.style.cssText = [
    'position:fixed',
    'inset:0',
    'z-index:9999',
    'background:#fff',
    'pointer-events:none',
    'opacity:1',
    'transition:opacity 0.55s cubic-bezier(0.76,0,0.24,1)'
  ].join(';');
  document.documentElement.appendChild(veil);

  /* Fade in on load */
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      veil.style.opacity = '0';
    });
  });

  /* Fade out on same-origin link clicks */
  if (!prefersReduced) {
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a') : null;
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href) return;
      /* Skip anchors, external, js, mail, tel, download */
      if (
        href.startsWith('#') ||
        href.startsWith('mailto') ||
        href.startsWith('tel') ||
        href.startsWith('javascript') ||
        a.hasAttribute('download') ||
        a.getAttribute('target') === '_blank'
      ) return;

      /* Skip if modifier key held */
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      /* Only same-origin */
      try {
        var url = new URL(href, window.location.href);
        if (url.origin !== window.location.origin) return;
      } catch (_) { return; }

      e.preventDefault();
      var dest = href;
      veil.style.transition = 'opacity 0.38s cubic-bezier(0.76,0,0.24,1)';
      veil.style.opacity = '1';
      setTimeout(function () {
        window.location.href = dest;
      }, 380);
    });
  }

  /* ================================================================
     2. CUSTOM CURSOR (desktop only)
  ================================================================ */
  var isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);



  /* ================================================================
     3. SMOOTH CLOCK SECOND HAND (continuous sweep)
     Finds the .hand--second inside the home-clock section and
     replaces the 1-second interval with a rAF continuous rotation.
  ================================================================ */
  function initSmoothClock() {
    var secEl = document.querySelector('.hand--second');
    if (!secEl) return;

    function getSmoothedSecondDeg() {
      var now = new Date();
      /* Get LA time offset */
      var laStr = now.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
      var la = new Date(laStr);
      var s = la.getSeconds() + la.getMilliseconds() / 1000;
      var m = la.getMinutes() + s / 60;
      return s * 6; /* 360° / 60s */
    }

    function sweepSec() {
      var deg = getSmoothedSecondDeg();
      secEl.style.transform = 'translate(-50%, -100%) rotate(' + deg.toFixed(3) + 'deg)';
      requestAnimationFrame(sweepSec);
    }
    requestAnimationFrame(sweepSec);
  }

  /* ================================================================
     4. HOMEPAGE PHOTO PARALLAX on mousemove
     Photos drift slightly toward the cursor for depth.
  ================================================================ */
  function initHomeParallax() {
    var clockSection = document.querySelector('.home-clock');
    if (!clockSection) return;

    var photos = clockSection.querySelectorAll('.photo');
    if (!photos.length) return;

    var W = window.innerWidth;
    var H = window.innerHeight;
    var targetX = 0, targetY = 0;
    var currX = 0, currY = 0;

    window.addEventListener('resize', function () {
      W = window.innerWidth;
      H = window.innerHeight;
    });

    document.addEventListener('mousemove', function (e) {
      /* Normalise to -1 … 1 */
      targetX = (e.clientX / W - 0.5) * 2;
      targetY = (e.clientY / H - 0.5) * 2;
    });

    (function parallaxLoop() {
      currX += (targetX - currX) * 0.04;
      currY += (targetY - currY) * 0.04;

      photos.forEach(function (photo, i) {
        /* Each photo gets a slightly different depth multiplier */
        var depth = 6 + (i % 3) * 3; /* 6, 9, or 12 px max shift */
        var tx = currX * depth;
        var ty = currY * depth;
        photo.style.willChange = 'transform';
        photo.style.transform = 'translate(' + tx.toFixed(2) + 'px, ' + ty.toFixed(2) + 'px)';
      });

      requestAnimationFrame(parallaxLoop);
    })();
  }

  /* ================================================================
     5. WHEEL IMAGE CROSSFADE
     Patches the image-set viewer to crossfade between images
     by layering two <img> tags and fading the outgoing one out.
  ================================================================ */
  function initViewerCrossfade() {
    /* Add a fade class to the viewer image when src changes */
    var style = document.createElement('style');
    style.textContent = [
      '.viewer__image {',
      '  transition: opacity 0.22s ease !important;',
      '}',
      '.viewer__image.is-fading {',
      '  opacity: 0 !important;',
      '}'
    ].join('\n');
    document.head.appendChild(style);

    /* Observe all viewer images for src changes */
    var images = document.querySelectorAll('.viewer__image');
    images.forEach(function (img) {
      var lastSrc = img.src;
      var obs = new MutationObserver(function () {
        if (img.src !== lastSrc) {
          lastSrc = img.src;
          img.classList.add('is-fading');
          /* Let the new src load then fade in */
          var fresh = new Image();
          fresh.onload = function () {
            img.classList.remove('is-fading');
          };
          fresh.src = img.src;
          /* Safety: remove class after 300ms even if onload is late */
          setTimeout(function () { img.classList.remove('is-fading'); }, 300);
        }
      });
      obs.observe(img, { attributes: true, attributeFilter: ['src'] });
    });
  }

  /* ================================================================
     6. HEADER SCROLL GLASS EFFECT
     Adds a very subtle frosted backdrop as soon as user scrolls
  ================================================================ */
  function initHeaderScroll() {
    var header = document.getElementById('rm-header');
    if (!header) return;

    var style = document.createElement('style');
    style.textContent = [
      '#rm-header {',
      '  transition: background 0.4s ease, backdrop-filter 0.4s ease;',
      '}',
      '#rm-header.is-scrolled {',
      '  background: rgba(255,255,255,0.72) !important;',
      '  backdrop-filter: saturate(180%) blur(14px);',
      '  -webkit-backdrop-filter: saturate(180%) blur(14px);',
      '}'
    ].join('\n');
    document.head.appendChild(style);

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        header.classList.toggle('is-scrolled', window.scrollY > 10);
        ticking = false;
      });
    }, { passive: true });
  }

  /* ================================================================
     9. ABOUT PAGE — text reveal on load
  ================================================================ */
  function initAboutReveal() {
    var about = document.querySelector('.about-section, [class*="about"]');
    if (!about) return;
    var text = about.querySelector('p, .about__text, [class*="text"]');
    if (!text) return;

    text.style.opacity = '0';
    text.style.transform = 'translateY(16px)';
    text.style.transition = 'opacity 0.7s ease 0.2s, transform 0.7s cubic-bezier(0.76,0,0.24,1) 0.2s';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        text.style.opacity = '1';
        text.style.transform = 'translateY(0)';
      });
    });
  }

  /* ================================================================
     INIT — run after DOM ready
  ================================================================ */
  function init() {
    if (!prefersReduced) {
      initSmoothClock();
      initHomeParallax();
      initHeaderScroll();
        }
    initViewerCrossfade();
    initAboutReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
